import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { BuyButton } from './BuyButton';
export function Pricing() {
  return <section id="comprar" className="w-full bg-sage-band py-20 md:py-28" data-id="element-102" data-mp="2aphrj6gl25xq">
      <div className="mx-auto max-w-2xl px-6 text-center" data-id="element-103" data-mp="2ohxp3rqptbr9">
        <p className="mb-4 font-sans text-xs uppercase tracking-[0.3em] text-sage" data-id="element-104" data-mp="2jjcmjlnzqfzn">
          Empezá hoy
        </p>
        <h2 className="font-serif text-4xl leading-tight text-ink md:text-5xl" data-id="element-105" data-mp="1vutf18crm78m">
          Basta de sostenerlo todo.
        </h2>
        <p className="mx-auto mt-5 max-w-lg font-sans text-base leading-relaxed text-ink-soft" data-id="element-106" data-mp="1ruja7z0plmvc">
          Descarga inmediata en PDF y EPUB. Incluye los 3 bonos y garantía de 7
          días.
        </p>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mx-auto mt-12 max-w-md bg-cream p-10 shadow-[0_30px_60px_-30px_rgba(51,50,31,0.3)]" data-id="element-107" data-mp="20v7psy5r3vac">
          <p className="font-sans text-xs uppercase tracking-[0.25em] text-muted" data-id="element-108" data-mp="9srzrp1euu8f">
            Precio en Argentina
          </p>
          <div className="mt-6 flex items-baseline justify-center gap-4" data-id="element-109" data-mp="eoz81oha4htj">
            <span className="font-serif text-2xl text-muted line-through" data-id="element-110" data-mp="3dail9ql4ral3">
              AR$ 29.999
            </span>
            <span className="font-serif text-5xl text-ink" data-id="element-111" data-mp="3i5xxke3hoyfe">AR$ 14.999</span>
          </div>
          <p className="mt-3 font-sans text-sm font-medium uppercase tracking-[0.14em] text-sage" data-id="element-112" data-mp="3n5tww018s1om">
            50% OFF · Pago único
          </p>
          <div className="mt-8" data-id="element-113" data-mp="2uizj1lyxk0k4">
            <BuyButton variant="solid" size="lg" className="w-full" data-id="element-114" data-mp="2uhy6te66h80t">
              Comprar ahora
            </BuyButton>
          </div>
          <p className="mt-5 flex items-center justify-center gap-2 font-sans text-sm text-ink-soft" data-id="element-115" data-mp="2zf7v2qhtzdn2">
            <CheckCircleIcon size={16} className="text-sage" data-id="element-116" data-mp="2mhrv7upmds6a" />
            Acceso inmediato al confirmar el pago
          </p>
        </motion.div>
      </div>
    </section>;
}